import { render, staticRenderFns } from "./AverageRoomTemps.vue?vue&type=template&id=aec840aa&"
import script from "./AverageRoomTemps.vue?vue&type=script&lang=ts&"
export * from "./AverageRoomTemps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports